import React, { useContext, useEffect, useState } from "react";
import { Button, Layout, Icon } from "@app/components";
import { AuthContext } from "@app/providers";
import { useLocation } from "@app/utils";
import { BoyImage, GirlImage } from "@app/assets";
import {
  SuccessContainer,
  SuccessHeading,
  SuccessText,
} from "./educator-component";
import { TextCenter } from "@app/components/commonStyles";
import { ButtonContainer } from "@app/components/header/header.component";
import { PopUpContainer, PopUpSubTitle, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";

export default function EducatorWelcomeScreen() {
  
  const { navigate } = useLocation();
  const { userInfo } = useContext(AuthContext);
  const [accountSetup, setAccountSetUp] = useState<boolean>(false);
  const [educatorApprovedFlag, setEducatorApprovedFlag] = useState<boolean>(false);
  const userToken = userInfo && userInfo.sessionToken;

  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };


  useEffect(() => {
    if (userInfo) {
      const accountSetUpCompleted: any =
        (userInfo.userJson.educatorLicenseType === "schoolLicenseCode" &&
          !userInfo.userJson.schoolName) ||
        (userInfo.userJson.educatorLicenseType === "teacherAccount" &&
          !userInfo.userJson.educatorGrade);
      setAccountSetUp(accountSetUpCompleted);
      setEducatorApprovedFlag(userInfo.userJson.educatorApprovedFlag);
    }
    if (userToken && userInfo.userJson.userType === "student" || userInfo.userJson.userType === "parent") {
      navigate('/pagenotfound')
    }
  }, [userInfo]);

  if (!educatorApprovedFlag && userInfo.userJson.educatorLicenseType === "teacherAccount") {
    return (
      <Layout className="aligned-center">
        <SuccessContainer>
          <Icon name="pending" />
          <SuccessHeading>Approval Pending</SuccessHeading>
          <SuccessText>You will get notified to your email address once your account has been approved.</SuccessText>
        </SuccessContainer>
      </Layout>
    );
  }
  else if (!accountSetup && userInfo.userJson.type !== 'KazooSchoolCode') {
    return (
      <Layout
        className="flexed aligned-center"
        classname="custom-message centered"
      >
        <h3 className="primary-header-logo">Welcome to KazooBadoo!</h3>
        <p className="content my-20">
          Please select an option to continue to move to the next step
        </p>
        <Button
          variant="newsecondary"
          customClass="mb-10"
          onClick={handleOpenPopup}
          width="300px"
        >
          Submit Content and Monetize
        </Button>
        <Button
          variant="newsecondary"
          width="300px"
          onClick={() => navigate("/create-classroom")}
        >
          Create a Classroom
        </Button>
        <img alt="" className="left-aligned-image" src={BoyImage} />
        <img alt="" className="right-aligned-image" src={GirlImage} />
        {isPopupOpen && (
        <div className="popup-overlay">
          <PopUpWrapper>
            <PopUpContainer>
              <Icon name="pending" />
              <span className="close-icon" onClick={handleClosePopup} >
                <Icon name="close" />
              </span>
              <PopUpTitle>Coming soon</PopUpTitle>
              <PopUpSubTitle>
                The feature is not available.
              </PopUpSubTitle>
            </PopUpContainer>
          </PopUpWrapper>
        </div>
        )}
      </Layout>
    );
  }else if (!accountSetup && userInfo.userJson.type == 'KazooSchoolCode') {
    return (
      <Layout
        className="flexed aligned-center"
        classname="custom-message centered"
      >
        <h3 className="primary-header">Welcome to KazooBadoo!</h3>
        <p className="content my-20">
          Please select an option to continue to move to the next step
        </p>
        <Button
          variant="newsecondary"
          customClass="mb-10"
          onClick={handleOpenPopup}
          width="300px"
        >
          Submit Content and Monetize
        </Button>
        <img alt="" className="left-aligned-image" src={BoyImage} />
        <img alt="" className="right-aligned-image" src={GirlImage} />
        {isPopupOpen && (
        <div className="popup-overlay">
          <PopUpWrapper>
            <PopUpContainer>
              <Icon name="pending" />
              <span className="close-icon" onClick={handleClosePopup} >
                <Icon name="close" />
              </span>
              <PopUpTitle>Coming soon</PopUpTitle>
              <PopUpSubTitle>
                The feature is not available.
              </PopUpSubTitle>
            </PopUpContainer>
          </PopUpWrapper>
        </div>
        )}
      </Layout>
    );
  }else {
    return (
      <Layout className="aligned-center">
        <SuccessContainer>
          <Icon name="pending" />
          <SuccessHeading>Your Account has been Approved!</SuccessHeading>
          <SuccessText>Next step to configure your account.</SuccessText>
          <ButtonContainer className="w-unset">
            <Button variant="newsecondary" customClass="w-unset" onClick={() => navigate("/account-setup")}>
              Configure Account
          </Button>
          </ButtonContainer>
          {/* <TextCenter>
          Click here to
            <button
              className="anchor-tag"
              type="button"
              onClick={() => navigate("/account-setup")}
            >
              setup your account now.
            </button>
           
          </TextCenter> */}
        </SuccessContainer>
      </Layout>
    );
  }
}
